document.addEventListener('DOMContentLoaded', function(){
    const aside = document.querySelector('.facets-wrapper');
    const facetsContainer = aside.querySelector('.facets-container');
    const swiperData = document.querySelector('.swiper-data');
    if(swiperData){
        let { filterAfterCollection } = swiperData.dataset; 

        filterAfterCollection = filterAfterCollection === "true" ? true : false;
        
        const moveComponenent = () => {
            if(filterAfterCollection){
                if(window.innerWidth <= 767){
                    swiperData.insertAdjacentElement('beforeend', facetsContainer);
                } else {
                    aside.insertAdjacentElement('beforeend', facetsContainer);
                }
            }
            
        }

        window.addEventListener("resize", () => {
            moveComponenent();
        })

        moveComponenent();
    }
});